import React from 'react';
import HowItWorksCard from './HowItWorksCard';

const steps = [
  {
    id: 1,
    icon: '/home-5/learning/1.svg',
    title: 'Bac à sable',
    description: "Auto-apprentissage en ligne + tutorat 1:1 + sessions collectives."
  },
  {
    id: 2,
    icon: '/home-5/learning/2.svg',
    title: 'Dojos',
    description: "Ateliers pratiques intensifs orientés projet guidés par des experts."
  },
  {
    id: 3,
    icon: '/home-5/learning/3.svg',
    title: 'Lab',
    description: "Réalisation d'un projet concret, documenté et présenté."
  },
  {
    id: 4,
    icon: '/home-5/learning/4.svg',
    title: 'Certification',
    description: "Validation du projet final par un jury et obtention du certificat."
  }
];

const HowItWorks = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 px-4">
      <div className="container mx-auto">
        {/* Title */}
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-title font-bold mb-3 md:mb-4 text-dark-1">Comment ça marche ?</h2>
          <p className="text-gray-600 dark:text-gray-300 text-subtitle">
            Une pédagogie innovante basée sur un apprentissage pratique et hybride
          </p>
        </div>

        {/* Steps - Modifié pour afficher 2 cartes par ligne sur mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {steps.map((step) => (
            <React.Fragment key={step.id}>
              <HowItWorksCard
                key={step.id}
                id={step.id}
                image={step.icon}
                title={step.title}
                description={step.description}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;